import { useState } from 'react';
import { Snackbar } from '@mui/material';
import userApi from '../../../../api/userApi';
import StyledButton from '../../../Button';
import {
  StyledAppsContainer,
  StyledContainer,
  StyledLoader,
  StyledCreateAppContainer,
  StyledCreateAppTitle,
} from './styled';
import UserApp from '../UserApp';
import { NavLink } from 'react-router';

const AppsList = () => {
  const { data, isLoading, isError } = userApi.useGetUserAppsQuery();
  const { data: userInfo, isError: isUserInfoError } =
    userApi.useGetUserInfoQuery();

  const [isSnackbarShown, setIsSnackbarShown] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);

  const showErrorSnackbar = (msg: string) => {
    setSnackbarMessage(msg);
    setIsSnackbarShown(true);
  };

  if (isLoading) {
    return <StyledLoader />;
  }
  if (isError || isUserInfoError || !data || !userInfo) {
    return null;
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isSnackbarShown}
        autoHideDuration={6000}
        onClose={() => setIsSnackbarShown(false)}
        message={snackbarMessage}
      />
      <StyledContainer>
        {data.length ? (
          <StyledAppsContainer>
            {data.map((app) => (
              <UserApp key={app.id} app={app} onError={showErrorSnackbar} />
            ))}
          </StyledAppsContainer>
        ) : (
          <StyledCreateAppContainer>
            <StyledCreateAppTitle>
              You’ve not created an app yet
            </StyledCreateAppTitle>

            {/* @ts-expect-error component is actually handled correctly here */}
            <StyledButton component={NavLink} to={'new'}>
              Create App
            </StyledButton>
          </StyledCreateAppContainer>
        )}
      </StyledContainer>
    </>
  );
};

export default AppsList;
